export default "__VITE_ASSET__BEuJtZaN__"